import React from 'react';
import { Box, Card, Typography } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import TrendingDownIcon from '@material-ui/icons/TrendingDown';
import RemoveIcon from '@material-ui/icons/Remove';
import { tint } from '../colors';

const NAMED_COLORS = {
  blue: '#2874E8', green: '#16B981', orange: '#FF7A26', purple: '#9B5CFF',
};

const resolveTheme = (color) => {
  const hex = NAMED_COLORS[color] || color || NAMED_COLORS.blue;
  return { color: hex, light: tint(hex) };
};

const TrendBadge = ({ type, value }) => {
  const isUp = type === 'up';
  const isDown = type === 'down';

  return (
    <Box style={{ display: 'flex', alignItems: 'center', gap: 3, padding: '4px 8px', borderRadius: 8, backgroundColor: isUp ? '#EAFBF5' : isDown ? '#FFF0F1' : '#F1F4F8', color: isUp ? '#13A875' : isDown ? '#EF4444' : '#718096' }}>
      {isUp && <TrendingUpIcon style={{ fontSize: 13 }} />}
      {isDown && <TrendingDownIcon style={{ fontSize: 13 }} />}
      {!isUp && !isDown && <RemoveIcon style={{ fontSize: 13 }} />}
      <Typography style={{ fontSize: 11, fontWeight: 600, lineHeight: 1 }}>{value}</Typography>
    </Box>
  );
};

const KPICard = ({ title, value, subtitle, color = 'blue', icon: Icon, trend, trendType = 'up', onClick, loading }) => {
  const theme = resolveTheme(color);

  if (loading) {
    return (
      <Card elevation={0} style={{ borderRadius: 10, border: `1px solid ${theme.light}`, background: '#FFFFFF', overflow: 'hidden', boxShadow: '0 4px 18px rgba(15, 23, 42, 0.05)' }}>
        <Box style={{ padding: '12px 16px' }}>
          <Box style={{ display: 'flex', alignItems: 'center' }}>
            <Skeleton variant="rect" width={30} height={30} style={{ borderRadius: 8 }} />
            <Skeleton variant="text" width={90} height={16} style={{ marginLeft: 10 }} />
          </Box>
          <Skeleton variant="text" width={70} height={30} style={{ marginTop: 6 }} />
          <Skeleton variant="text" width={110} height={16} style={{ marginTop: 4 }} />
        </Box>
      </Card>
    );
  }

  return (
    <Card
      elevation={0}
      onClick={onClick}
      style={{ position: 'relative', borderRadius: 10, border: `1px solid ${theme.light}`, background: '#FFFFFF', overflow: 'hidden', boxShadow: '0 4px 18px rgba(15, 23, 42, 0.05)', cursor: onClick ? 'pointer' : 'default' }}
    >
      {/* <Box style={{ position: 'absolute', right: -20, top: 10, width: 70, height: 70, borderRadius: '50%', background: theme.light, opacity: 0.45 }} /> */}

      <Box style={{ position: 'relative', padding: '12px 16px', boxSizing: 'border-box' }}>
        <Box style={{ display: 'flex', alignItems: 'center' }}>
          <Box style={{ width: 30, height: 30, borderRadius: 8, backgroundColor: theme.light, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            {Icon && <Icon style={{ fontSize: 16, color: theme.color }} />}
          </Box>
          <Typography style={{ marginLeft: 10, fontSize: 12, fontWeight: 600, letterSpacing: '0.2px', color: '#65758F', textTransform: 'uppercase' }}>
            {title}
          </Typography>
        </Box>

        <Box style={{ display: 'flex', alignItems: 'center', marginTop: 6, gap: 8 }}>
          <Typography style={{ fontSize: 24, lineHeight: 1, fontWeight: 700, color: '#182235', letterSpacing: '-0.5px' }}>
            {value}
          </Typography>
          {trend && <TrendBadge type={trendType} value={trend} />}
        </Box>

        <Typography style={{ marginTop: 4, fontSize: 12, color: '#66758C' }}>
          {subtitle}
        </Typography>
      </Box>
    </Card>
  );
};

export default KPICard;
